
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { ApplicationFormValues } from "./formSchema";

interface MotivationSectionProps {
  form: UseFormReturn<ApplicationFormValues>;
}

export function MotivationSection({ form }: MotivationSectionProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">3. Motivation (facultatif)</h3>
      
      <FormField
        control={form.control}
        name="motivation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Pourquoi souhaitez-vous rejoindre cette opération ?</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Expliquez en quelques mots ce qui vous motive à participer"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
